// domain/usecase/roster/GetRosterFinancialsUseCase.kt
package com.evoapps.evoshift.domain.usecase.roster

import com.evoapps.evoshift.domain.model.RosterFinancials
import com.evoapps.evoshift.domain.repository.FinancialRepository

class GetRosterFinancialsUseCase(
    private val financialRepository: FinancialRepository
) {
    suspend operator fun invoke(rosterId: String): Result<RosterFinancials> {
        return financialRepository.getRosterFinancials(rosterId)
    }
}